import React, { useState } from 'react'
//Helpers
import flecha from './flecha.svg'
import axios from 'axios'
import ReCAPTCHA from 'react-google-recaptcha'
import image1 from './image1.jpg'
import image2 from './image2.jpg'
import image3 from './image3.jpg'
import Slider from 'react-slick'

import LogoFlamma from './logo_flamma.svg'
import { RealEstateDataPageComponentData } from 'types'
import { useDispatch } from 'react-redux'
import { useCreateFormMutation as useSendContactFormMutationLanding } from '@apis/mediacore/contact'
import Image from '@components/Image'
import { getImage } from 'gatsby-plugin-image'
import { ElementHTML } from '@helpers/helper.rendering'

const settings = {
  autoplay: true,
  dots: false,
  infinite: true,
  speed: 5000,
  items: 3,
  fade: true,
  slidesToShow: 1,
}

const isBrowser = typeof window !== 'undefined'

const LandingPerfo = ({
  global_data,
  opacityValue,
  title,
  subtitle,
  paragraphs,
  titleElement,
  titleHexa,
  paragraphHexa,
  sliderImages, //Slider imagenes
  image_bottom_gatsby, // Logo
  arrayImages, // Flag
  image, //Bullet
  items, //Logos inferiores,
  backgroundColor, //Color de la placa
  is_short, //Degrade
  subtitleElement,
  subtitleHexa,
}: RealEstateDataPageComponentData) => {
  //function current year
  const getCurrentYear = () => {
    const currentYear = new Date().getFullYear()
    return currentYear
  }

  const LandingText = () => {
    return (
      <div className="col-lg-6">
        <div
          id="flag-section"
          className="d-flex flex-column"
        >
          {image_bottom_gatsby && (
            <Image
              image={image_bottom_gatsby!}
              className={'logo-superior'}
              objectFit={'cover'}
              alt={'landing-img'}
            />
          )}
          <div className="d-flex">
            {arrayImages?.map(({ image }) => (
              <img
                src={image}
                className={'logo-flag me-3'}
                alt={'landing-img'}
              />
            ))}
          </div>
          {title && (
            <div className="my-lg-0 my-3">
              {title?.split('\n').map((tit) => (
                <ElementHTML
                  children={tit || ''}
                  className="m-lg-0"
                  elementType={titleElement || 'h2'}
                  style={{ color: titleHexa || '#fff' }}
                />
              ))}
            </div>
          )}
          {subtitle && (
            <div className="my-4 mb-5 mb-lg-4">
              {subtitle?.split('\n').map((sub) => (
                <ElementHTML
                  children={sub || ''}
                  className="m-0"
                  elementType={subtitleElement || 'h4'}
                  style={{ color: subtitleHexa || '#fff' }}
                />
              ))}
            </div>
          )}
        </div>

        <div className="feature-wrap">
          {paragraphs?.map((paragraph) => (
            // <div className="d-flex flex-column align-items-lg-center align-items-lg-start mt-3 mt-lg-0">
            <div className="d-flex flex-column align-items-lg-start mt-3 mt-lg-0">
              <h4
                style={{ color: paragraphHexa || '#fff' }}
                className="d-flex align-items-start"
              >
                <img
                  src={image}
                  className="flecha"
                  alt="flecha"
                  style={{ marginTop: '.5rem', height: 16 }}
                />
                <div className="d-block">
                  {paragraph.split('\n').map(
                    (para, index) =>
                      (paragraph.split('\n').length - 1 > index ||
                        paragraph.split('\n').length === 1) && (
                        <div
                          key={index}
                          className="d-block"
                        >
                          {para} <br />
                        </div>
                      ),
                  )}
                </div>
              </h4>
            </div>
          ))}
        </div>
        <div className="d-lg-flex d-none bottom-logos mt-lg-3 mt-5">
          {items?.map((item) => (
            <div className="d-lg-flex justify-content-center white text-center me-lg-5 flex-column logo-item">
              {
                <span className={'text-white ' + (item.title ? '' : 'd-none d-lg-block')}>
                  {item.title}
                </span>
              }
              <img
                src={item.image}
                alt=""
              />
            </div>
          ))}
        </div>
      </div>
    )
  }

  return (
    isBrowser && (
      <section
        className="perfo-landings c"
        id=""
      >
        <div
          className={'opacity '}
          style={{
            background: is_short
              ? 'linear-gradient(to right, ' + backgroundColor + 'ff, ' + backgroundColor + '00)'
              : backgroundColor || '#f1f1f1',
            opacity:
              opacityValue && opacityValue !== '0'
                ? Number(opacityValue) !== 100
                  ? `0.${Number(opacityValue)}`
                  : 1
                : 0.6,
          }}
        ></div>
        <div className="d-flex">
          <Slider
            {...settings}
            lazyLoad="ondemand"
            className="overflow-hidden"
          >
            {sliderImages?.map(({ image }) => (
              <img
                style={{ height: '100vh' }}
                src={image}
                alt=""
              />
            ))}
          </Slider>
          <div className="container-fluid">
            <div
              className="row align-items-center"
              id="main-section"
            >
              <div className="col-12">
                <div className="row align-items-center justify-content-between">
                  <LandingText />
                  {/* <ContactForm global_data={global_data} /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer
          className="mt-3 mt-lg-0 d-lg-block d-none "
          style={{ textAlign: 'center' }}
        >
          <p
            style={{ color: '#fff' }}
            className="copy"
          >
            Promoted by{' '}
            <a
              target="_blank"
              className="normal-color"
              href="https://mediahaus.com.ar"
            >
              {' '}
              MediaHaus
            </a>{' '}
            - Powered by{' '}
            <a
              target="_blank"
              className="white"
              href="https://mediacore.app/"
              style={{ color: '#fff' }}
            >
              {' '}
              MediaCore
            </a>
            <br />
            <span className="small-text">Todos los derechos reservados ® {getCurrentYear()}</span>
          </p>
        </footer>
      </section>
    )
  )
}

const ContactForm = ({ global_data }: RealEstateDataPageComponentData) => {
  const [submitted, setSubmitted] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const [sendContactForm] = useSendContactFormMutationLanding()
}

export default LandingPerfo
